/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Cancel_ThanksInputs */

const en_dialog_cancel_thanks = /** @type {(inputs: Dialog_Cancel_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanks for giving us a try! We hope you'll come back in the future`)
};

const es_dialog_cancel_thanks = /** @type {(inputs: Dialog_Cancel_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Gracias por darnos una oportunidad! Esperamos que vuelvas en el futuro`)
};

/**
* | output |
* | --- |
* | "Thanks for giving us a try! We hope you'll come back in the future" |
*
* @param {Dialog_Cancel_ThanksInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_cancel_thanks = /** @type {((inputs?: Dialog_Cancel_ThanksInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Cancel_ThanksInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_cancel_thanks(inputs)
	return en_dialog_cancel_thanks(inputs)
});